import { READY_DOMAINS } from "@/lib/questionnaire";
import { EvidenceMapperRow } from "@/components/intake/EvidenceMapperRow";

export function EvidenceMapper({ section, answers, onChange, displayNumberFor }) {
  const items = section.items || [];
  const groups = READY_DOMAINS
    .map((d) => ({
      ...d,
      items: items.filter((it) => it.domain === d.key)
    }))
    .filter((g) => g.items.length > 0);

  const answeredCount = items.filter((i) => answers[i.id]).length;

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 rounded-sm border border-border bg-card/60 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
            Evidence mapper instructions
          </p>
          <p className="mt-1 text-sm leading-relaxed text-foreground/85">
            First mark each item's applicability, then the evidence condition for applicable items:
            <span className="font-mono-label ml-2 text-[11px] text-foreground">APPLICABLE · NOT APPLICABLE (explanation required) · NEEDS CLARIFICATION</span>.
          </p>
        </div>
        <div className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground sm:text-right">
          {answeredCount} / {items.length} answered
        </div>
      </div>

      {groups.map((group) => (
        <section key={group.key} className="paper-card overflow-hidden">
          <header className="flex items-center gap-4 border-b border-border bg-card/80 px-5 py-4">
            <span className="letter-mark h-9 w-9 text-base shadow-paper">{group.key}</span>
            <div className="flex flex-col leading-tight">
              <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                Domain
              </span>
              <span className="font-display text-base font-medium text-foreground">{group.title}</span>
            </div>
            <span className="font-mono-label ml-auto text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
              {group.items.length} item{group.items.length === 1 ? "" : "s"}
            </span>
          </header>
          <div className="divide-y divide-border">
            {group.items.map((item) => (
              <EvidenceMapperRow
                key={item.id}
                item={item}
                value={answers[item.id]}
                naReason={answers[`${item.id}__na_reason`] || ""}
                evidenceNote={answers[`${item.id}__evidence_note`] || ""}
                verification={answers[`${item.id}__verification`] || ""}
                onChange={(value) => onChange(item.id, value)}
                onReasonChange={(text) => onChange(`${item.id}__na_reason`, text)}
                onEvidenceNoteChange={(text) => onChange(`${item.id}__evidence_note`, text)}
                onVerificationChange={(status) => onChange(`${item.id}__verification`, status)}
                displayNumber={displayNumberFor ? displayNumberFor(item.id) : undefined}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
